export default __webpack_public_path__ + "static/ssJuegosVisualmacc-fc25eb954cbe3ba751ab9060d1e23072.jpg";